// extracted by mini-css-extract-plugin
module.exports = {"aside":"_9e1425b4d3--aside--c3IjO"};